import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from './util/axios'
import storage from './util/storage'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// import store from './store'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (!storage.get('token') && to.meta.login == 1) {
    storage.set('frompath', to.path)
    next({ path: "/login", replace: true })
  }
  next()
})

router.afterEach((to, from) => {

})

const goPage = function (url) {
  router.push(url);
}

const exportData = function (url, param, fileName) {
  axios({
    url: url,
    data: param,
    responseType: 'blob'
  }).then(res => {
    let blob = new Blob([res]);
    if ("download" in document.createElement("a")) {
      // 不是IE浏览器
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 下载完成移除元素
      window.URL.revokeObjectURL(url); // 释放掉blob对象
    } else {
      // IE 10+
      window.navigator.msSaveBlob(blob, fileName);
    }
  })
}

const saveInfo = function (infoName) {
  return new Promise((resolve) => {
    // this.tempInfo = {}
    // for (let item in this[infoName]) {
    //   this.tempInfo[item] = this[infoName][item];
    // }
    // this.tempInfo = Object.assign({}, this[infoName])
    this.tempInfo = JSON.parse(JSON.stringify(this[infoName]));
    console.log(this.tempInfo)
    resolve()
  })
}
const resetInfo = function (infoName) {
  const temp = JSON.parse(JSON.stringify(this.tempInfo));
  for (let item in this[infoName]) {
    this[infoName][item] = temp[item]
  }
  console.log(this[infoName])
}

const isMobile = function () {
  return /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
      navigator.userAgent
  );
}

const getCommonInfo = function (options) {
  return new Promise((resolve) => {
    axios({
      url: '/base/getCommonInfo',
      data: {
        info: options
      },
      showInfo:0
    }).then(res => {
      if (res.status === 1) {
        for (let item in options) {
          this[options[item]] = res[options[item]];
        }
      }
      resolve()
    })
  })
}

const getUploadUrl = function(url){
  return window.host+'/'+window.app+url
}

const pic = function(url,refresh=false){
  return url?storage.get('picHost')+url+(refresh?'?'+new Date().getTime():''):'';
}

const picList = function (arr,key=null){
  let temp = [];
  arr.forEach(item=>{
    const url = key===null?item:item[key];
    if(url){
      temp.push(pic(url))
    }
  })
  return temp;
}

const getUrlParam = function (key=''){
  const searchParams = new URLSearchParams(window.location.search);
  if (key === '') {
    const temp = {};
    searchParams.forEach((value, key) => {
      temp[key]=value;
    })
    return temp;
  } else {
    return searchParams.has(key) ? searchParams.get(key) : false;
  }
}

const hideloading = function () {
  this.loading = false
}
const showloading = function (){
  this.loading = true
}

const handleCurrentChange = function(p) {
  this.page = p;
  this.getlist();
}
const handleSizeChange=function(size){
  this.pagesize = size;
  this.page = 1;
  this.getlist();
}

const getDate = function(str){
  const date = new Date();
  let time,weekday,month
  switch(str){
    case 'toweekend':
      weekday = date.getDay() || 7
      date.setDate(date.getDate() - weekday + 7)
      time = date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate() +
          ' 23:59:59'
      break
    case 'premonth':
      month = date.getMonth() - 1;
      date.setMonth(month)
      month = month < 0 ? 11 : month;
      time =
          date.getFullYear() +
          '-' +
          (month + 1) +
          '-' +
          '01'
      break
    case 'premonthend':
      month = date.getMonth();
      if(month === 0){
        month = 11;
        date.setMonth(month);
        date.setFullYear(date.getFullYear()-1);
      }
      time =
          date.getFullYear() +
          '-' +
          month +
          '-' +
          new Date(date.getFullYear(), month, 0).getDate()
          +
          ' 23:59:59'
      break
    case 'start':
      time =
          date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          '01'
      break
    case 'toweek':
      weekday = date.getDay() || 7
      date.setDate(date.getDate() - weekday + 1)
      time = date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate()
      break
    case 'crntyear':
      time = date.getFullYear() + '-01-01';
      break
    default:
      // 当天24点
      time =
          date.getFullYear() +
          '-' +
          (date.getMonth() + 1) +
          '-' +
          date.getDate()
  }
  return time
}

app.config.globalProperties.tempInfo = {}
app.config.globalProperties.isMobile = isMobile()
app.config.globalProperties.HOST = window.host
app.config.globalProperties.loading = false
app.config.globalProperties.page = 1
app.config.globalProperties.total = 0
app.config.globalProperties.formLabelWidth = '120px'
app.config.globalProperties.pagesizes = ['15', '30', '50', '100', '1000']
app.config.globalProperties.pagesize = 15
app.config.globalProperties.layout = isMobile()?'prev, pager, next':'total, sizes, prev, pager, next, jumper'

app.mixin({
  methods: {
    $axios: axios,
    $setStorage: storage.set,
    $getStorage: storage.get,
    $removeStorage: storage.remove,
    $clearStorage: storage.clear,
    $goPage: goPage,
    $exportData: exportData,
    $saveInfo: saveInfo,
    $resetInfo: resetInfo,
    $getCommonInfo: getCommonInfo,
    $getUploadUrl:getUploadUrl,
    $pic:pic,
    $picList:picList,
    $hideloading:hideloading,
    $showloading:showloading,
    $handleCurrentChange:handleCurrentChange,
    $handleSizeChange:handleSizeChange,
    $getUrlParam:getUrlParam,
    $getDate:getDate
  }
})

app.use(ElementPlus, {
  locale: zhCn,
})


app.use(router).mount('#app')
